<template>
  <div class="animated fadeIn col-md-12">
    <LoadingSpinner :loading="isLoading" />

    <div v-if="!isLoading">
      <b-card border-variant="default" :no-body="false">
        <div slot="header">
          <b class="flex">
            عملیات تحقیق ({{ $lang.researcher }}:

            <ProfileBoxPopupWrapper
              :data="research"
              deskTopPopupClass="top-230"
              nameClass="color-complementary margin-right-4"
            >
          </ProfileBoxPopupWrapper>
            )
          </b>
        </div>
        <b-row>
          <b-col cols="12">
            <CardAudienc :audience="audienceData" :img_kind="img_kind" />
          </b-col>
        </b-row>

        <b-row class="m-0">
          <b-col cols="12" class="px-0 mt-3">
            <b-card :no-body="true">
              <template #header>
                <b-row>
                  <b-col class="col-12 col-md-6 d-flex align-items-center">
                    <strong>
                      {{ $lang.researchPlan }}
                    </strong>
                  </b-col>
                  <b-col class="col-12 col-md-6">
                    <div class="float-right">
                      <!-- header-filter -->
                      <b-button
                        @click="isCollapsed = !isCollapsed"
                        :class="
                          isCollapsed
                            ? 'btn-success ml-2'
                            : 'btn-lightgray ml-2'
                        "
                      >
                        <i
                          :class="
                            isCollapsed ? 'fa fa-angle-up' : 'fa fa-angle-down'
                          "
                        ></i>
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </template>
              <b-collapse
                id="collapseSearchTable"
                :visible="isCollapsed"
                class="p-3"
              >
                <Search
                  ref="searchResearchPlan"
                  :url="url"
                  :hiddenFields="hiddenFields"
                  :allowFields="$lang.researchLang.searchResearchPlan"
                  :title="$lang.researchPlan"
                  :remove_item="remove_item"
                  :filterCatch="false"
                  :toggleable="true"
                  addModalSize="lg"
                  removeModalSize="xl"
                  :dynamicButtons="buttons"
                  :defaultViewCount="50"
                  primaryKey="id"
                  :openNewTab="false"
                  routeName="editTaskAdmin"
                  :params="{ research_relation_id: id }"
                  :parentPermissions="parentPermissions"
                  @getPermisson="updatePermissions"
                  :visibleAdd="
                    isAdmin(parentPermissions, ['admin']) &&
                    research_status_id === 2
                  "
                >
                  <template slot="addModal" slot-scope="search">
                    <AddResearchPlan
                      :query="$route.query"
                      :parentPermissions="parentPermissions"
                      @closeModal="search.close"
                      @getData="getData"
                    />
                  </template>
                </Search>
              </b-collapse>
            </b-card>
          </b-col>
        </b-row>

        <b-row class="m-0">
          <b-col cols="12" class="px-0 mt-3">
            <ExamPackList
              title="لیست پرسشنامه‌های ارزیاب تحقیقات"
              :showAdminList="
                includes('modir_tahghigh', roles) ||
                includes('modir_system', roles)
              "
              :finishCheck="includes(research_status_id, [3, 4])"
              :finishMessage="`به علت اتمام تحقیق در تاریخ ${complete_at_jalali} امکان تغییر داده‌های پرسشنامه‌ها نیست`"
              :azmoonId="audienceAzmoonId"
              :personCode="audienceParvandehCode"
              :operatorCode="researcherParvandehCode"
              :referenceCode="researcherPersonCode"
            />
          </b-col>
          <b-col
            cols="12"
            class="px-0 mt-3"
            v-if="
              researcherManagerAzmoonId &&
              includes(research_status_id, [4]) &&
              (includes('modir_tahghigh', roles) ||
                includes('modir_system', roles))
            "
          >
            <ExamPackList
              title="لیست پرسشنامه‌های مدیر تحقیق"
              :azmoonId="researcherManagerAzmoonId"
              :personCode="audienceParvandehCode"
              :operatorCode="researcherManagerParvandehCode"
              :referenceCode="researcherManagerPersonCode"
            />
          </b-col>
        </b-row>
        <b-row class="m-0">
          <b-col cols="12" md="12" class="px-0 mt-3">
            <UploadFile
              caption="پیوست تحقیق"
              keyServies="research_in_queue"
              :keyValue="id"
              attachment_type_name="attachment_type_research"
              attachmentRoute="attachment_research"
              :parentAttachmentTypeId="24"
              :file_types="file_types"
              :showAdd="!includes(research_status_id, [3, 4])"
              :showForm="false"
              :crop="false"
              :parentPermissions="parentPermissions"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-button
              v-if="research_status_id === 2"
              @click="removing()"
              class="float-right mt-3"
              variant="success"
              :disabled="isLoadingBtn"
            >
              <div v-if="!isLoadingBtn">
                {{ $lang.end_researcher }}
                <mdicon name="check" size="24" />
              </div>
              <div v-if="isLoadingBtn">
                <span v-text="$lang.search.loading_send" class="mr-2" />
                <b-spinner small></b-spinner>
              </div>
            </b-button>
            <b-button
              v-if="
                includes(research_status_id, [3, 4]) &&
                (includes('modir_system', roles) ||
                  includes('modir_arshad_tahghigh', roles) ||
                  includes('modir_tahghigh', roles))
              "
              @click="patchEndResearch(2)"
              class="float-right mr-1 mt-3"
              variant="danger"
              :disabled="isLoadingBtn"
            >
              <div v-if="!isLoadingBtn">
                {{ $lang.back_researcher }}
                <mdicon name="check" size="24" />
              </div>
              <div v-if="isLoadingBtn">
                <span v-text="$lang.search.loading_send" />
                <b-spinner small></b-spinner>
              </div>
            </b-button>
            <b-button
              v-if="research_status_id === 2"
              class="float-right mr-1 mt-3"
              variant="warning"
              :disabled="isLoadingBtn"
              @click="showCloseResearchPlanModal()"
            >
              {{ $lang.close_researcher }}
              <mdicon name="close" size="24" />
            </b-button>
            <b-button
              v-if="
                includes(research_status_id, [4]) &&
                (includes('modir_tahghigh', roles) ||
                  includes('modir_system', roles))
              "
              class="float-right mr-1 mt-3"
              :variant="
                researchManagerAzmoonDoneId === 1 ? 'success' : 'warning'
              "
              :disabled="azmoonDoneConfirmLoading"
              @click="azmoonDoneConfirm = true"
            >
              <div>
                <div v-if="researchManagerAzmoonDoneId === 1">
                  <span v-text="$lang.accept_azmoon_done" />
                  <mdicon name="check" size="24" />
                </div>
                <div v-if="researchManagerAzmoonDoneId === 2">
                  <span v-text="$lang.reject_azmoon_done" />
                  <mdicon name="close" size="24" />
                </div>
              </div>
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <Confirm
      :title="modalTitle"
      :loading="isLoadingBtn"
      :loadingSpinnerText="$lang.updating_data"
      :description="message"
      dynamicClass=""
      v-model="removemodal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="confirmedRemoveItem"
      @cancel="notConfirmedRemoveItem"
    />
    <Confirm
      :title="azmoonDoneConfirmTitle"
      :loading="azmoonDoneConfirmLoading"
      :loadingSpinnerText="$lang.updating_data"
      :description="azmoonDoneConfirmDescription"
      dynamicClass=""
      v-model="azmoonDoneConfirm"
      :ok-title="$lang.modal_ok"
      :cancel-title="$lang.cancelButton"
      @ok="setResearchManagerAzmoonDone"
      @cancel="azmoonDoneConfirm = false"
    />
    <b-modal
      no-close-on-backdrop
      v-model="view_add"
      size="xl"
      ok-only
      hide-header
      hide-footer
    >
      <EditResearchPlan
        :query="$route.query"
        v-if="mode === 'edit' && editItem"
        :parentPermissions="parentPermissions"
        :item="editItem"
        @closeModal="closeModal"
        @getData="getData"
      />
      <CloseResearchPlan
        v-if="mode === 'close'"
        @closeModal="closeModal"
        @refreshPlanDetail="fetchData"
      />
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import ExamPackList from "@/components/base/ExamPackList";
import AddResearchPlan from "./addResearchPlan";
import EditResearchPlan from "./editResearchPlan";
import CloseResearchPlan from "./closeResearchPlan";
import CardAudienc from "./cardAudienc";
import Confirm from "@/components/base/confirm";
import UploadFile from "@/components/base/uploadFile";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr, includes } from "ramda";
import { isAdmin, generateApiUrl, generateStoreGetters } from "@/shared/utils";
import { ProfileBoxPopupWrapper } from "@/components/re-design";

export default {
  name: "search-research-plan",
  components: {
    Search,
    Confirm,
    AddResearchPlan,
    EditResearchPlan,
    CloseResearchPlan,
    CardAudienc,
    UploadFile,
    ExamPackList,
    LoadingSpinner,
    ProfileBoxPopupWrapper,
  },
  data() {
    return {
      modalTitle: "",
      message: "",
      removemodal: false,
      mode: "",
      editItem: null,
      itemResearcher: null,
      audience: {},
      id: this.$route.params.id,
      hiddenFields: [],
      isLoading: false,
      isLoadingBtn: false,
      view_add: false,
      researcher: {},
      researcherManager: {},
      locations: {},
      research_status_id: null,
      researchManagerAzmoonDoneId: null,
      azmoonDoneConfirm: false,
      azmoonDoneConfirmLoading: false,
      complete_at: "",
      buttons: [
        {
          id: "0",
          name: "edit",
          click: this.modalEdit,
        },
        {
          id: "1",
          name: "view",
          click: this.modalEdit,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      parentPermissions: [],
      file_types: ["image", "office", "media", "other"],
      isCollapsed: false,
    };
  },
  computed: {
    roles() {
      return generateStoreGetters(["userInfo", "roles"]) || [];
    },
    audienceData() {
      return {
        parvandeh_code: pathOr("", ["parvandeh", "code"], this.audience),
        code: pathOr(null, ["person", "code"], this.audience),
        full_name:
          pathOr("", ["person", "name"], this.audience) +
          " " +
          pathOr("", ["person", "family"], this.audience),
        birth_date: pathOr({}, ["person", "birth_date"], this.audience),
        marriage: pathOr({}, ["person", "marriage"], this.audience),
        religion: pathOr({}, ["person", "religion"], this.audience),
        allegiance: pathOr("", ["person", "allegiance"], this.audience),
        last_address: pathOr("", ["person", "last_address"], this.audience),
        biography: pathOr("", ["person", "biography"], this.audience),
        license: pathOr({}, ["person", "license"], this.audience),
        azmoonId: pathOr(null, ["azmoon", "id"], this.audience),
        parvandehNumber: pathOr(
          "",
          ["parvandeh", "parvandeh_number"],
          this.audience
        ),
        termName: pathOr("", ["parvandeh", "term", "caption"], this.audience),
        status_end_reason: pathOr(
          "",
          ["parvandeh", "status_end_reason"],
          this.audience
        ),
        interview_status: pathOr("", ["interview_status"], this.audience),
        parvandeh_status: pathOr(null, ["parvandeh", "status"], this.audience),
      };
    },
    research() {
      return {
        code: pathOr("", ["person", "code"], this.researcher),
        full_name:
          pathOr("", ["person", "name"], this.researcher) +
          " " +
          pathOr("", ["person", "family"], this.researcher),
      };
    },
    img_kind() {
      const imgKind = pathOr(
        "",
        ["person", "img_kind", "address"],
        this.audience
      );
      return imgKind || this.$config.images.shared.noPerson;
    },
    generateModalTitle() {
      switch (this.mode) {
        case "add":
          return this.$lang.addResearchPlan;
        case "edit":
          return this.$lang.editResearchPlan;
        default:
          return "";
      }
    },
    audienceAzmoonId() {
      return pathOr(null, ["azmoon", "id"], this.audience);
    },
    researcherManagerAzmoonId() {
      return pathOr(null, ["azmoon", "id"], this.researcherManager);
    },
    audienceParvandehCode() {
      return pathOr(null, ["parvandeh", "code"], this.audience);
    },
    researcherParvandehCode() {
      return pathOr(null, ["parvandeh", "code"], this.researcher);
    },
    researcherPersonCode() {
      return pathOr(null, ["person", "code"], this.researcher);
    },
    researcherManagerParvandehCode() {
      return pathOr(null, ["parvandeh", "code"], this.researcherManager);
    },
    researcherManagerPersonCode() {
      return pathOr(null, ["person", "code"], this.researcherManager);
    },
    azmoonDoneConfirmTitle() {
      return this.researchManagerAzmoonDoneId === 1
        ? this.$lang.accept_azmoon_done
        : this.$lang.reject_azmoon_done;
    },
    azmoonDoneConfirmDescription() {
      const text =
        this.researchManagerAzmoonDoneId === 1
          ? `تحقیق و بررسی صورت گرفته مورد تایید اینجانب میباشد`
          : `تحقیقات انجام شده نیازمند تکمیل فرایند از سمت محقق است

`;
      return `<div class='text-justify'>${text}</div>`;
    },
    url() {
      return generateApiUrl(["research", "research_queue_plan"], [this.id]);
    },
  },
  watch: {
    research_status_id(value) {
      this.parentPermissions = includes(value, [3, 4]) ? ["view"] : [];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    removing() {
      this.message = this.$lang.researchPlanConfirm;
      this.modalTitle = this.$lang.remove_item;
      this.removemodal = true;
    },
    async confirmedRemoveItem() {
      this.modalTitle = "بروزرسانی اطلاعات";
      await this.patchEndResearch(4);
      this.removemodal = false;
    },
    notConfirmedRemoveItem() {
      this.removingItem = null;
      this.message = "";
      this.removemodal = false;
    },
    async patchEndResearch(research_status_id) {
      try {
        this.isLoadingBtn = true;
        const url =
          this.$config.api_url +
          this.$config.research.research_plan_detail.replace("{0}", this.id);
        const response = await this.$httpService.patch(url, {
          research_status_id,
        });
        this.$notify.success(response.data.message);
        this.fetchData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoadingBtn = false;
      }
    },
    openNewTab(path) {
      let routeData = this.$router.resolve(path);
      window.open(routeData.href, "_blank");
    },
    closeModal() {
      this.view_add = false;
    },
    getData() {
      this.view_add = false;
      this.$refs.searchResearchPlan.getItems();
    },
    modalEdit(item) {
      this.editItem = item;
      this.mode = "edit";
      this.view_add = true;
    },
    modalAdd() {
      this.mode = "add";
      this.view_add = true;
    },
    async fetchData() {
      try {
        this.isLoading = true;
        const url =
          this.$config.api_url +
          this.$config.research.research_plan_detail.replace("{0}", this.id);
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.itemResearcher = data;
        this.audience = pathOr({}, ["audience"], data);
        this.researchManagerAzmoonDoneId = pathOr(
          null,
          ["research_manager_azmoon_done", "id"],
          data
        );
        this.researcher = pathOr({}, ["researcher"], data);
        this.researcherManager = pathOr({}, ["research_manager"], data);
        this.locations = pathOr({}, ["location"], data);
        this.research_status_id = pathOr(null, ["research_status", "id"], data);
        this.complete_at_jalali = pathOr("", ["complete_at", "jalali"], data);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async remove_item(item) {
      try {
        this.isLoading = true;
        const researchId = pathOr(null, ["id"], item);
        const url =
          this.$config.api_url +
          this.$config.research.research_queue_plan_detail
            .replace("{0}", this.id)
            .replace("{1}", researchId);
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    updatePermissions(permissions) {
      this.parentPermissions = [...permissions];
    },
    showCloseResearchPlanModal() {
      this.mode = "close";
      this.view_add = true;
    },
    async setResearchManagerAzmoonDone() {
      try {
        this.azmoonDoneConfirmLoading = true;
        const url = generateApiUrl(
          ["research", "research_queue_research_manager_azmoon"],
          [this.id]
        );
        const payload = {
          is_research_manager_azmoon_done:
            this.researchManagerAzmoonDoneId === 1 ? 2 : 1,
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.fetchData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.azmoonDoneConfirm = false;
        this.azmoonDoneConfirmLoading = false;
      }
    },
  },
};
</script>

<style>
.text-h-main {
  position: absolute;
  top: -11px;
  right: 29px;
  background: white;
  width: 124px;
  text-align: center;
  z-index: 11;
}
</style>
